import { render, staticRenderFns } from "./svgicon.vue?vue&type=template&id=666d86de"
import script from "./svgicon.vue?vue&type=script&lang=js"
export * from "./svgicon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports